import { render, staticRenderFns } from "./partners-index.vue?vue&type=template&id=58122ec6&"
import script from "./partners-index.vue?vue&type=script&lang=js&"
export * from "./partners-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports